// Generated by ts-to-zod
import { z } from "zod";
import { SettingType } from "./SettingType.d";

export * from "./SettingType.d";

export const settingTypeSchema = z.nativeEnum(SettingType);
